import { SCUIContent } from '../../atomic/organisms';
import { AIGenerationTypeSelector } from './components/AIGeneration/AIGenerationTypeSelector';

export const AIGenerationTypeSelectorPage = () => {
    return (
        <SCUIContent>
            <AIGenerationTypeSelector />
        </SCUIContent>
    );
};

